import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { setResults } from "state/slices/user/userSlice";
import { useSearchUsersQuery } from "state/slices/search/searchApiSlice";
import Employee from "components/Employee";

const SearchViewManagement = ({
  isAllowedToUpdate,
  isAllowedToDelete,
  deleteEmployee,
  handleEditEmployee,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchTerm = searchParams.get("s") || "";

  const dispatch = useDispatch();
  const results = useSelector((state) => state.employee.results);

  const {
    data: retrievedUsers,
    error,
    isError,
    refetch,
    isLoading: isResultsLoading,
    isFetching,
  } = useSearchUsersQuery(searchTerm, {
    skip: !searchTerm,
  });

  const currentResults = (() => {
    if (isError && !isResultsLoading && !isFetching) {
      return [];
    }
    if (retrievedUsers !== undefined && Array.isArray(retrievedUsers)) {
      return retrievedUsers;
    }
    return results || [];
  })();

  useEffect(() => {
    if (!isResultsLoading && !isFetching) {
      if (isError && error) {
        dispatch(setResults([]));
      } else if (retrievedUsers !== undefined && Array.isArray(retrievedUsers)) {
        dispatch(setResults(retrievedUsers));
      } else if (!searchTerm) {
        dispatch(setResults([]));
      }
    }
  }, [retrievedUsers, error, isError, isResultsLoading, isFetching, dispatch, searchTerm]);

  return (
    <Row>
      {isResultsLoading || isFetching ? (
        <div className="text-center pt-5 pb-5">
          <p>Loading...</p>
        </div>
      ) : currentResults && currentResults.length > 0 ? (
        currentResults.map((result, index) => (
          <Col
            lg={result?.designation?._id === result.id ? 4 : 3}
            key={result.id}
          >
            <Employee
              employee={result}
              deleteEmployee={deleteEmployee}
              handleEdit={handleEditEmployee}
              isAllowedToUpdate={isAllowedToUpdate}
              isAllowedToDelete={isAllowedToDelete}
            />
          </Col>
        ))
      ) : (
        <div className="text-center pt-5 pb-5">
          <h1>
            <strong>404</strong>
          </h1>
          <h4 className="mb-4">Oops! Search Not Found.</h4>
        </div>
      )}
    </Row>
  );
};

export default SearchViewManagement;
